import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { PhasesSection } from '../components/PhasesSection';
import { AgendaSection } from '../components/AgendaSection';
import { RouteMapSection } from '../components/RouteMapSection';
import { VenueMapSection } from '../components/VenueMapSection';
import { PetWallSection } from '../components/PetWallSection';
import { TicketsSection } from '../components/TicketsSection';
import { SponsorsSection } from '../components/SponsorsSection';
import { ActivitiesSection } from '../components/ActivitiesSection';
import { LocationSection } from '../components/LocationSection';
import { CauseSection } from '../components/CauseSection';
import { ContactSection } from '../components/ContactSection';
import { SponsorsBannerSection } from '../components/SponsorsBannerSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-2215" />
      <ActivitiesSection data-id="element-2216" />
      <AboutSection data-id="element-2217" />
      <TicketsSection data-id="element-2218" />
      <CauseSection data-id="element-2219" />
      <SponsorsBannerSection data-id="element-2220" />
      <SponsorsSection data-id="element-2221" />
      <AgendaSection data-id="element-2222" />
      <RouteMapSection data-id="element-2223" />
      <VenueMapSection data-id="element-2224" />
      <PetWallSection data-id="element-2225" />
      <LocationSection data-id="element-2226" />
      <PhasesSection data-id="element-2227" />
      <ContactSection data-id="element-2228" />
    </>;
}